module.exports = __webpack_public_path__ + "img/0.fdbcf1f1.png";